/* src/app/components/session/session-expiry-warning/session-expiry-warning.component.css */
dialog.session-expiry-warning {
  z-index: 2147483647;
  width: 480px;
  max-width: calc(100vw - 32px);
  border: 0;
  padding: 0;
  margin: auto;
  font-family:
    Arial,
    Helvetica,
    sans-serif;
  border-radius: 16px;
  overflow: hidden;
}
dialog.session-expiry-warning::backdrop {
  z-index: 2147483647;
  background-color: var(--color-grey-600);
  opacity: 0.6;
}
.session-expiry-warning__header {
  background: var(--color-grey-100);
  padding: 12px 24px;
  text-align: center;
}
.session-expiry-warning__title {
  font-family:
    Arial,
    Helvetica,
    sans-serif;
  margin: 0;
  color: var(--color-grey-800);
  font-size: 1.1em;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.03em;
}
.session-expiry-warning__content {
  font-family:
    Arial,
    Helvetica,
    sans-serif;
  text-align: center;
  padding: 24px;
  margin: 0;
}
.session-expiry-warning__message {
  font-family:
    Arial,
    Helvetica,
    sans-serif;
  color: var(--color-grey-700);
  font-weight: 400;
  margin: 0 0 20px;
}
.session-expiry-warning__countdown-box {
  display: inline-block;
  min-width: 140px;
  margin: 0 0 20px;
  padding: 10px 24px;
  background: var(--color-error-background);
  border: 1px solid var(--color-error-outline);
  border-radius: 8px;
}
#session-expiry-countdown {
  font-family:
    Arial,
    Helvetica,
    sans-serif;
  color: var(--color-error-text);
  font-size: 1.75em;
  font-weight: 600;
}
.session-expiry-warning__hint {
  font-family:
    Arial,
    Helvetica,
    sans-serif;
  color: var(--color-grey-500);
  font-weight: 400;
  font-size: 0.9em;
  margin: 0;
}
.session-expiry-warning__actions {
  display: flex;
  justify-content: center;
  padding: 0 24px 24px;
  margin: 0;
}
.session-expiry-warning__extend-btn {
  font-family:
    Arial,
    Helvetica,
    sans-serif;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  text-transform: uppercase;
  border-radius: 6px;
}
.session-expiry-warning__extend-icon {
  font-size: 0.7em;
}
/*# sourceMappingURL=session-expiry-warning.component.css.map */
